var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('iframe',{staticStyle:{"width":"100%","height":"620px"},attrs:{"src":"user-guide-medhop/index.html","frameborder":"0"}})])])
}]

export { render, staticRenderFns }